export interface Sponsor {
	uuid: string;
	moduleUuid: string;
	moduleFor: string;
	sponsorLevelId: SponsorLevel;
	logoUrl: string;
	title: string;
	url: string;
	amount: number;
	tagline: string;
	dateCreated: Date;
	dateDisabled: Date | null;
	createdByUuid: string;
	updatedByUuid: string | null;
}

export interface SponsorLevelWithSponsors {
	sponsorLevelId: SponsorLevel;
	sponsorLevelTitle: string;
	systemSponsors: Sponsor[];
}

export enum SponsorLevel {
	GOLD = 'Gold',
	SILVER = 'Silver',
	PLATINUM = 'Platinum',
	BRONZE = 'Bronze',
	PARTNER = 'Partner',
	NO_LEVEL = 'No level',
	TOUR = 'Tour',
	PLATINUM_PADDLE = 'Platinum paddle',
	GOLD_PADDLE = 'Gold paddle',
	SILVER_PADDLE = 'Silver paddle',
	TITLE_SPONSOR = 'Title sponsor'
}
